import { z } from "zod";
import { END_NUMBER, RANGE_DESCRIPTION, START_NUMBER, WARNING_PERCENTAGE } from "./consts";

export const rangeSchema = z.object({
  [START_NUMBER]: z.string().min(1, "This field is required"),
  [END_NUMBER]: z.string().min(1, "This field is required"),
  [RANGE_DESCRIPTION]: z.string().optional(),
  [WARNING_PERCENTAGE]: z.string().min(1, "This field is required"),
}).refine((data) => Number(data[START_NUMBER]) <= Number(data[END_NUMBER]), {
  message: "End number must be greater than or equal to start number",
  path: [END_NUMBER],
});